<template>
  <div class="container">
    <!-- 主体内容 -->
    <Boyo-Content ref="BoyoContent"
                  :loading="content.loading">
      <!-- 表格头部按钮 -->
      <BoyoButton :buttonList="buttonList"
                  @handClick="handClick">
      </BoyoButton>
      <div style="float:left;margin-bottom:10px;font-size:16px">
        <span>价格本编号：</span>
        <el-input
          size='small'
          style="width:140px"
          v-model="formDate.billNo"
          :disabled="true">
        </el-input>
        <span>价格本标题：</span>
        <el-input
          size='small'
          style="width:140px"
          v-model="formDate.billTitle"
          :disabled="true">
        </el-input>
        <span>执行时间：</span>
        <el-date-picker
          size='small'
          style="width:190px"
          v-model="formDate.billStartTime"
          :disabled="true"
          type="datetime">
        </el-date-picker>
        <!-- <span>组织：</span>
        <el-input
          size='small'
          style="width:140px"
          v-model="formDate.tissueName"
          :disabled="true">
        </el-input> -->
      </div>
      <!-- 表格 -->
      <el-table :data="tableInfo2.data"
                border
                max-height="550px"
                style="width: 100%"
                :header-cell-style="{background:'#f7f8f9',color:'#3C3C3C',padding:'4px 0',border:'1px solid #e5e7e8' }"
                :cell-style="{padding:'2px'}"
                @row-click="handleCellChange">
        <el-table-column prop="areaName"
                        label="区域"
                        width="120px" align="center">
        </el-table-column>
        <template v-for="item of tableInfo2.fieldList">
            <el-table-column v-for="(child,index) of item.basePriceAreaList"
                              :key="index"
                              :label="child.label"
                              align="center">
                <el-table-column label="基价" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.basePriceAreaList[index].childs[0].basePrice" oninput="value=value.replace(/[^\d]/g,'')" @input="areaAddPriceInput(scope.row.basePriceAreaList,index,'basePrice')">
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="areaAddPrice"
                                  label="区域加价" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.basePriceAreaList[index].childs[1].areaAddPrice" @input="areaAddPriceInput(scope.row.basePriceAreaList,index,'areaAddPrice')">
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="areaPrice"
                                  label="区域价格" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.basePriceAreaList[index].childs[2].areaPrice" disabled>
                        <!-- readonly -->
                      </el-input>
                    </template>
                  </el-table-column>
            </el-table-column>
        </template>
        <!-- <el-table-column prop="materialName"
                        label="物料"
                        width="140px" align="center">
        </el-table-column>
        <el-table-column prop="basePrice"
                        label="基础价格" align="center">
          <template slot-scope="scope">
            <el-input size="small"
                      v-model="scope.row.basePrice"
                      @input="areaPriceNum(scope.row,type = 'over')"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="areaAddPrice"
                        label="区域加价" align="center">
          <template slot-scope="scope">
            <el-input size="small"
                      v-model="scope.row.areaAddPrice"
                      @input="areaPriceNum(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="areaPrice"
                        label="区域价格" align="center">
        </el-table-column> -->
      </el-table>
    </Boyo-Content>
  </div>
</template>

<script>
import BoyoFilter from '@/components/BoyoFilter'
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
import BoyoTable from '@/components/BoyoTable'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import { rule, validateSort } from '@/utils/rules'
export default {
  name: 'BasicPriceAdd',
  components: {
    BoyoFilter,
    BoyoContent,
    BoyoButton,
    BoyoTable,
    BoyoDialog,
    BoyoForm
  },
  props: {},
  data () {
    let nowDate = new Date() 
    var year = nowDate.getFullYear();
    var mother = nowDate.getMonth() > 8 ? (nowDate.getMonth() + 1) : ('0' + (nowDate.getMonth() + 1));
    var day = (nowDate.getDate()) > 9 ? (nowDate.getDate()) : ('0' + (nowDate.getDate()));
    var hour = nowDate.getHours() > 9 ? (nowDate.getHours()) : ('0' + nowDate.getHours());
    var minute = nowDate.getMinutes() > 9 ? (nowDate.getMinutes()) : ('0' + nowDate.getMinutes());
    var second = nowDate.getSeconds() > 9 ? (nowDate.getSeconds()) : ('0' + nowDate.getSeconds());
    var newDay = year + '-' + mother + '-'+ day +' '+ hour + ':' + minute + ':' + second
    return {
      newDay,
      search: {},
      add2:0,
      tableData:[],
      tableDataAdd:[],//区域表添加
      tableDataAddSum:[],//各个区域表合添加
      tableDataCus:[],
      tableDataCusLoading:false,//客户价格本表格加载状态
      basePrice:[],//导入生效基价
      formDate:{
        tissueName:JSON.parse(localStorage.BasicPriceDate).tissueName,
        tissueId:JSON.parse(localStorage.BasicPriceDate).tissueId,
        billNo:JSON.parse(localStorage.BasicPriceDate).billNo,
        billTitle:JSON.parse(localStorage.BasicPriceDate).billTitle,
        billStartTime:JSON.parse(localStorage.BasicPriceDate).billStartTime,
        partnerId:'',//用于批量保存客户价格本
        partnerName:'',
        partnerCode:'',
        saleType:'',
        projectId:'',
        projectCode:'',
        projectName:'',
      },
      // 表格头部按钮相关
      buttonList: {
        // 左按钮
        left: [
          { icon: "el-icon-back", style: "background:#fff;color:#666;border:1px solid #666;margin-right:10px", desc: "返回", event: "back" },
          { icon: "el-icon-refresh-left", style: "background:#fff;color:#666;border:1px solid #666;margin-right:10px", desc: "重置", event: "refresh" },
          { icon: "el-icon-bottom", style: "background:#fff;color:#666;border:1px solid #666", desc: "导入生效基价", event: "addPriceBook" },
          { icon: 'el-icon-edit', style: 'background:#34afbb', desc: '保存区域价格本', event: 'create' },
          // { icon: 'el-icon-check', style: 'background:#18a689', desc: '审核', event: 'check' },
          // { icon: 'el-icon-plus', style: 'background:#1a7bb9', desc: '添加客户价格本', event: 'createCus' },
        ],
        right: [
        ]
      },
      //主体内容是否加载
      content: {
        loading: false
      },
      listTypeInfo:{
        validStatus:[{value:0,label:'未审核'},{value:1,label:'已审核'}],
        cancleStatus:[{value:0,label:'否'},{value:1,label:'作废'}],
        tissueId:[],
        baseStatus:[{value:0,label:'否'},{value:1,label:'是'}],//是否基价
        bagFlag:[{value:0,label:'散装'},{value:1,label:'袋装'}],//袋装标识
        partnerId:[],//客户
        saleType:[{value:0,label:'区域'},{value:1,label:'项目'}],//销售类型
        projectId:[],//客户项目
        unitName:[],//单位
      },
      //表格相关
      tableInfo2: {
        data: [],//数据
        fieldList: [
          // { value: 'areaName', label: '区域', show: true, dropdown: true },
          { value: 'materialName', label: '区域价格本', show: true, dropdown: true,basePriceAreaList:[] },
        ]
      },
    }
  },
  mounted () {
    if (localStorage.loginTissueId) {
      this.listTypeInfo.tissueId = [{value:parseInt(localStorage.loginTissueId),label:localStorage.loginTissueName}]
    } else {
      this.$api.organization.getSysTissuePage({pageNum: 1, pageSize: 999}).then(res => {//组织
          if(res.code == 0) {
              let list3 = res.data.list
              for( let i in list3 ) {
                  this.listTypeInfo.tissueId.push({value: parseInt(list3[i].id), label: list3[i].tissueName})
              }
          }
      })
    }
    this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,categoryCode:'Unit'}).then(res => {//枚举（单位）
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.unitName.push({value: list1[i].enumName, label: list1[i].enumName})
            }
        }
    })
    // this.$api.Region.getBaseAreaPage({pageNum: 1, pageSize: 999}).then(res => {
    //   if (res.code !== 0) {
    //     this.$message({ message: res.msg, type: "error" });
    //   }else{
    //     this.treeInfo.treeData = res.data.list;
    //     this.treeInfo.treeName = res.data.list[0].areaName
    //     this.buttonList.left[3].desc='保存修改'+this.treeInfo.treeName+'区域价格本'
    //     this.getInfo()
    //   }
    // })
    this.$api.Material.getBaseMaterialPage({pageNum: 1,pageSize: 999}).then(res => {//物料
      if (res.code == 0) {
        for(let i in res.data.list){
          if (res.data.list[i].materialType == 1||res.data.list[i].materialType == 2) {
            this.tableInfo2.fieldList[0].basePriceAreaList.push({ value: res.data.list[i].materialId, label: res.data.list[i].materialName,prop:'materialId'+Number(res.data.list[i].materialId)})
          }
        }
      }
    })
    this.getInfo()
  },
  methods: {
    areaAddPriceInput(row,i,type){
      // console.log(row[i].childs[0].basePrice)
      row[i].basePrice = row[i].childs[0].basePrice
      row[i].areaAddPrice = row[i].childs[1].areaAddPrice
      row[i].areaPrice = Number(row[i].basePrice) + Number(row[i].areaAddPrice)
      row[i].childs[2].areaPrice = row[i].areaPrice
      if (type == 'basePrice') {
        for (let ifv of this.tableInfo2.data) {
          ifv.basePriceAreaList.forEach((itm1 ,index1)=>{
            if (row[i].materialId == itm1.materialId) {
              itm1.basePrice = row[i].basePrice
              itm1.childs[0].basePrice = row[i].basePrice
              itm1.areaPrice = Number(itm1.basePrice) + Number(itm1.areaAddPrice)
              itm1.childs[2].areaPrice = itm1.areaPrice
            }
          })
        }
      }
    },
    // },
    areaPriceNum(row,type){//添加算区域价格
      // console.log(row.basePrice,row.addPrice,row.areaAddPrice);
      // if (type=='over') {
      //   for (let index of this.tableData) {
      //     index.basePrice = row.basePrice
      //     if (index.baseStatus == 0) {
      //       index.addPrice = 0
      //       index.areaAddPrice = 0
      //       index.areaPrice = Number(index.basePrice)
      //     }else{
      //       index.areaPrice = Number(index.basePrice)+Number(index.addPrice)+Number(index.areaAddPrice)
      //     }
      //   }
      // }else{
        // if (row.baseStatus == 0) {
        //   row.addPrice = 0
        //   row.areaAddPrice = 0
        //   row.areaPrice = Number(row.basePrice)
        // }else{
          // row.areaPrice = Number(row.basePrice)+Number(row.addPrice)+Number(row.areaAddPrice)
          row.areaPrice = Number(row.basePrice)+Number(row.areaAddPrice)
        // }
      // }
      if (this.tableDataAddSum.length>0) {
        let s = 1
        for(let idf of this.tableDataAddSum){
          if (idf.areaId == row.areaId && idf.materialId == row.materialId) {
            s = 0
            idf.basePrice = row.basePrice
            idf.areaAddPrice = row.areaAddPrice
            idf.areaPrice = row.areaPrice
            return
          }
        }
        if (s == 1) {
          this.tableDataAddSum.push(row)
        }
      } else {
        this.tableDataAddSum.push(row)
      }
    },
    handleCellChange (row, column, event) {
      this.add2 = row.addIndex;
    },
    //搜索事件
    getInfo () {//区域物料表和价格本，没价格本就差区域加价表赋值
      // this.content.loading = true
      // this.$api.Region.getBaseAreaPage({pageNum:1,pageSize:999}).then(res => {
      //   if (res.code == 0) {
          // let arr = []
          // this.tableData = []
      //     let arr1 = res.data.list
      //     this.content.loading = false
      this.$api.Region.getBasePriceAreaPage({priceBookId:JSON.parse(localStorage.BasicPriceDate).priceBookId,pageSize:999,pageNum:1}).then(res => {
        if (res.code == 0) {
          let arr = []
          this.tableData = []
          if (res.data.list.length>0) {//有区域价格本
            let arr1 = res.data.list
            this.$api.Region.getBaseAreaPage({pageNum:1,pageSize:999}).then(res => {
               if (res.code == 0) {
                 let arr3 = res.data.list
                 this.$api.Material.getBaseMaterialPage({pageNum:1,pageSize:9999}).then(res => {
                  if (res.code == 0) {
                    let arr2 = res.data.list
                    for (let index of arr2) {
                      if (index.materialType == 1||index.materialType == 2) {
                        arr.push(index)
                      }
                    }
                    let addNum = 0
                    for (let index2 of arr3) {
                      this.tableData.push({areaId:index2.areaId,areaName:index2.areaName,addIndex:addNum,basePriceAreaList:[]})
                      for (let index3 of arr) {
                        this.tableData[addNum].basePriceAreaList.push({id:'',priceBookId:'',areaId:index2.areaId,areaName:index2.areaName,materialId:index3.materialId,materialName:index3.materialName,materialNo:index3.materialNo,materialSpec:index3.materialSpec,baseStatus:Number(index3.baseStatus),bagFlag:index3.bagFlag,basePrice:'',areaAddPrice:'',areaPrice:'',taxRate:index3.taxRate,unitName:index3.unitName,childs:[
                          {basePrice:''},
                          {areaAddPrice:''},
                          {areaPrice:''}
                        ]})
                      }
                      addNum++
                    }
                    this.tableInfo2.data = this.tableData
                    for (let inde of arr1) {
                      for (let ind of inde.basePriceAreaList) {
                        for (let inde3 of this.tableInfo2.data) {
                          for (let inde2 of inde3.basePriceAreaList) {
                            if (ind.areaId == inde2.areaId && ind.materialId == inde2.materialId) {
                              for (const key in ind) {
                                if (key in inde2) {
                                  if (key=='areaAddPrice' || key=='basePrice') {//key=='addPrice' || 
                                    inde2[key] = ind[key] ==0?'':ind[key]
                                    if (key=='basePrice') {
                                      inde2.childs[0].basePrice = ind[key] ==0?'':ind[key]
                                      if (inde2.areaAddPrice) {
                                        inde2.childs[2].areaPrice = Number(inde2.areaAddPrice)+Number(inde2.basePrice)
                                      }
                                    }
                                    if (key=='areaAddPrice') {
                                      inde2.childs[1].areaAddPrice = ind[key] ==0?'':ind[key]
                                      if (inde2.basePrice) {
                                        inde2.childs[2].areaPrice = Number(inde2.areaAddPrice)+Number(inde2.basePrice)
                                      }
                                    }
                                  } else {
                                    inde2[key] = ind[key]
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    this.$api.priceBook.getBaseAddAreaPage({pageSize:999,pageNum:1}).then(res => {//新区域查加价赋值（没有价格本id）
                      if (res.code == 0) {
                        if (res.data.list.length>0) {
                          for (let inde1 of res.data.list) {
                            for (let inde of inde1.baseAddAreaList) {
                              for (let indej3 of this.tableInfo2.data) {
                                for (let indej2 of indej3.basePriceAreaList) {
                                  if (inde.areaId == indej2.areaId && inde.materialId == indej2.materialId && !indej3.priceBookId) {
                                    for (const key in inde) {
                                      if (key in indej2) {
                                        if (key == 'areaAddPrice') {
                                          indej2[key] = inde[key]
                                          indej2.childs[1].areaAddPrice= inde[key]
                                          if (indej2.basePrice && indej2.areaAddPrice) {// && indej2.addPrice
                                            indej2.areaPrice = Number(indej2.basePrice) + Number(indej2.areaAddPrice)// + Number(indej2.addPrice)
                                            indej2.childs[2].areaPrice= indej2.areaPrice
                                          }else{
                                            indej2.basePrice = Number(0)// + Number(indej2.addPrice)
                                            indej2.childs[0].basePrice= indej2.basePrice
                                            indej2.areaPrice = Number(indej2.areaAddPrice)// + Number(indej2.addPrice)
                                            indej2.childs[2].areaPrice= indej2.areaPrice
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            } 
                          }
                        }
                      } else {
                        this.$message({ message: res.msg, type: 'error' })
                      }
                    })
                  } else {
                    this.content.loading = false
                    this.$message({ message: res.msg, type: 'error' })
                  }
                })
               }else{
                 this.$message({ message: res.msg, type: 'error' })
               }
            })
          }else{
            // this.$message({ message: '区域为空', type: 'warning' })
            this.$api.Region.getBaseAreaPage({pageNum:1,pageSize:999}).then(res => {
               if (res.code == 0) {
                 let arr1 = res.data.list
                 this.$api.Material.getBaseMaterialPage({pageNum:1,pageSize:9999}).then(res => {
                  if (res.code == 0) {
                    let arr2 = res.data.list
                    for (let index of arr2) {
                      if (index.materialType == 1||index.materialType == 2) {
                        arr.push(index)
                      }
                    }
                    let addNum = 0
                    for (let index2 of arr1) {
                      this.tableData.push({areaId:index2.areaId,areaName:index2.areaName,addIndex:addNum,basePriceAreaList:[]})
                      for (let index3 of arr) {
                        this.tableData[addNum].basePriceAreaList.push({id:'',priceBookId:'',areaId:index2.areaId,areaName:index2.areaName,materialId:index3.materialId,materialName:index3.materialName,materialNo:index3.materialNo,materialSpec:index3.materialSpec,baseStatus:Number(index3.baseStatus),bagFlag:index3.bagFlag,basePrice:'',areaAddPrice:'',areaPrice:'',taxRate:index3.taxRate,unitName:index3.unitName,childs:[
                          {basePrice:''},
                          {areaAddPrice:''},
                          {areaPrice:''}
                        ]})
                      }
                      addNum++
                    }
                    this.tableInfo2.data = this.tableData
                    for (let indv of this.basePrice) {
                      for (let inde2 of this.tableInfo2.data) {
                        for (let indea of inde2.basePriceAreaList) {
                          if (indv.areaId == indea.areaId && indv.materialId == indea.materialId) {
                            indea.basePrice = indv.basePrice
                            indea.childs[0].basePrice = indv.basePrice
                            if (indea.areaAddPrice || indea.areaAddPrice == 0) {
                              indea.areaPrice = Number(indea.basePrice)+Number(indea.areaAddPrice)
                              indea.childs[2].areaPrice = indea.areaPrice
                            }
                          }
                        }
                      }
                    }
                    this.$api.priceBook.getBaseAddAreaPage({pageSize:999,pageNum:1}).then(res => {
                      if (res.code == 0) {
                        if (res.data.list.length>0) {
                          for (let inde1 of res.data.list) {
                            for (let inde of inde1.baseAddAreaList) {
                              for (let inde3 of this.tableInfo2.data) {
                                for (let inde2 of inde3.basePriceAreaList) {
                                  if (inde.areaId == inde2.areaId && inde.materialId == inde2.materialId) {
                                    for (const key in inde) {
                                      if (key in inde2) {
                                        if (key == 'areaAddPrice') {
                                          inde2[key] = inde[key]
                                          inde2.childs[1].areaAddPrice= inde[key]
                                          if (inde2.basePrice && inde2.areaAddPrice) {// && inde2.addPrice
                                            inde2.areaPrice = Number(inde2.basePrice) + Number(inde2.areaAddPrice)// + Number(inde2.addPrice)
                                            inde2.childs[2].areaPrice= inde2.areaPrice
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            } 
                          }
                        }
                      } else {
                        this.$message({ message: res.msg, type: 'error' })
                      }
                    })
                  }else{
                    this.$message({ message: res.msg, type: 'error' })
                  }
                 })
               }else{
                 this.$message({ message: res.msg, type: 'error' })
               }
            })
          }
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
      //   } else {
      //     this.content.loading = false
      //     this.$message({ message: res.msg, type: 'error' })
      //   }
      // }, err => {
      //   this.content.loading = false
      // })
    },
    // 表格头部按钮相关事件
    handClick (event, data) {
      switch (event) {
        case 'create':
          // console.log(this.tableData)
          this.tableDataAdd=[]
          let tableDataUp=[]
          // for (let ind of this.tableDataAddSum) {
          for (let ins of this.tableInfo2.data) {
            for (let ind of ins.basePriceAreaList) {
              if (ind.id) {
                tableDataUp.push(ind)
              }else{
                this.tableDataAdd.push(ind)
              }
            }
          }
          for (let ind of this.tableDataAdd) {
            ind.priceBookId = JSON.parse(localStorage.BasicPriceDate).priceBookId
            ind.tissueName = this.formDate.tissueName
            ind.tissueId = this.formDate.tissueId
            ind.createTissueName = this.formDate.tissueName
            ind.createTissueId = this.formDate.tissueId
          }
          for (let indup of tableDataUp) {
            indup.priceBookId = JSON.parse(localStorage.BasicPriceDate).priceBookId
            indup.tissueName = this.formDate.tissueName
            indup.tissueId = this.formDate.tissueId
            indup.createTissueName = this.formDate.tissueName
            indup.createTissueId = this.formDate.tissueId
            // indup.addPrice = indup.addPrice?indup.addPrice:0
            indup.areaAddPrice = indup.areaAddPrice?indup.areaAddPrice:0
          }
          if (tableDataUp.length>0) {
            this.$api.Region.updateBasePriceAreaBatch({basePriceAreaUpdateFormList:tableDataUp}).then(res => {
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                this.$router.push('/index/system/BasicPrice')//返回基础价格本
                // this.getInfo()
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            })
          }
          if (this.tableDataAdd.length>0) {
            this.$api.Region.batchSaveBasePriceArea({basePriceAreaSaveFormList:this.tableDataAdd}).then(res => {
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                this.$router.push('/index/system/BasicPrice')//返回基础价格本
                // this.getInfo()
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            })
          }
          break
        case 'check':
          this.$api.Region.auditBasePriceArea({priceBookId:JSON.parse(localStorage.BasicPriceDate).priceBookId,auditMark:1,tstatus:1}).then(res => {
            if (res.code === 0) {
              this.$message({ message: res.msg, type: 'success' })
              this.getInfo()
            } else {
              this.$message({ message: res.msg, type: 'error' })
            }
          })
          break
        case "back":
          this.$router.push('/index/system/BasicPrice')//返回基础价格本
          break;
        case "refresh":
          this.getInfo()
          break
        case "addPriceBook":
          this.content.loading = true
          this.$api.priceBook.inEffectBasePriceAreaPage({tissueId:localStorage.loginTissueId}).then(res => {//客户
            if (res.code == 0) {
              this.basePrice =[]
              this.$message({ message: res.msg, type: 'success' })
              if (res.data.list.length>0) {
                for (let inf of res.data.list) {
                  for (let inde of inf.basePriceAreaList) {
                    this.basePrice.push({areaId:inde.areaId,materialId:inde.materialId,basePrice:inde.basePrice})
                    for (let inde1 of this.tableInfo2.data) {
                      for (let inde2 of inde1.basePriceAreaList) {
                        if (inde.areaId == inde2.areaId && inde.materialId == inde2.materialId) {
                          for (const key in inde) {
                            if (key in inde2) {
                              if (key == 'basePrice' && inde.basePrice) {// || key == 'basePrice' || key == 'addPrice' || key == 'areaPrice'
                                inde2[key] = inde[key] == 0?'':inde[key]
                                inde2.childs[0].basePrice = inde[key] == 0?'':inde[key]
                                if (inde2.areaAddPrice || inde2.areaAddPrice == 0) {
                                  inde2.areaPrice = Number(inde2.basePrice)+Number(inde2.areaAddPrice)
                                  inde2.childs[2].areaPrice = inde2.areaPrice
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    // for (let inde2 of this.tableData) {
                    //   if (inde.areaId == inde2.areaId && inde.materialId == inde2.materialId) {
                    //     for (const key in inde) {
                    //       if (key in inde2) {
                    //         if (key == 'basePrice') {// || key == 'basePrice' || key == 'addPrice' || key == 'areaPrice'
                    //           inde2[key] = inde[key] == 0?'':inde[key]
                    //           if (inde2.areaAddPrice) {
                    //             inde2.areaPrice = Number(inde2.basePrice)+Number(inde2.areaAddPrice)
                    //           }
                    //         }
                    //       }
                    //     }
                    //   }
                    // }
                  } 
                }
              }
              this.content.loading = false
            } else {
              this.$message({ message: res.msg, type: 'error' })
              this.content.loading = false
            }
          })
          break
      }
    },
  }
}
</script>
<style lang="stylus" scoped>
.tree-Bar
  position absolute
  top 0
  left 180px
  bottom 0
  width 8px
  background #fafafa
  border 1px solid #eee
  display flex
  justify-content center
  align-items center
.tree-buttons
  height 45px
  line-height 45px
  border-bottom 1px solid #eee
  font-size 16px
  color #676a6c
</style>


// WEBPACK FOOTER //
// src/views/pages/System/BasicPriceAdd.vue